export const DEFAULT_PAGE_SIZE = 20;

export const PAGE_SIZE_OPTIONS: string[] = ['10', '20', '50', '100'];

export const TABLE_SCROLL_Y = 600;

export const TIMESTAMP_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
	month: 'short',
	day: '2-digit',
	year: 'numeric',
	hour: '2-digit',
	minute: '2-digit',
	second: '2-digit',
	hour12: false
} as const;
